import { logger } from '@lusha/client-logger';
import { flow, getRoot } from 'mobx-state-tree';
import { fetchUgcData, fetchUgcSettings, sendUserAnswer, updateUgcSettings } from '../../../API/ugcApi';
const Actions = self => ({
    fetchUgcUserSettings: flow(function* fetchUgcUserSettings() {
        var _a, _b;
        const { user: { id }, } = getRoot(self);
        self.isLoaded = false;
        try {
            const settings = yield fetchUgcSettings(`userId=${id}`);
            self.invalidAnswers = !settings[0] ? 0 : (_a = settings[0]) === null || _a === void 0 ? void 0 : _a.invalidAnswers;
            self.isValid = !(settings === null || settings === void 0 ? void 0 : settings[0]) || ((_b = settings[0]) === null || _b === void 0 ? void 0 : _b.invalidAnswers) < 2;
            if (self.isValid) {
                yield self.fetchUserUgcData(id);
            }
            self.isLoaded = true;
        }
        catch (e) {
            logger.warn('failed to fetch UgcSettings');
        }
    }),
    checkForInvalidAnswer: flow(function* checkForInvalidAnswer(key, feedback) {
        var _a, _b, _c;
        if (((_a = self.currentContact[key]) === null || _a === void 0 ? void 0 : _a.feedback) && !feedback) {
            self.setAlreadyAnswered((_b = self.currentContact) === null || _b === void 0 ? void 0 : _b.contactId);
            if (self.alreadyAnswered) {
                const { user: { id }, } = getRoot(self);
                yield self.updateInvalidAnswers(id, (_c = self.currentContact) === null || _c === void 0 ? void 0 : _c.contactId);
                yield fetchUgcSettings();
            }
        }
    }),
    sendUserFeedback: flow(function* sendUserFeedback(data) {
        try {
            yield sendUserAnswer(data);
            yield self.fetchUgcUserSettings();
        }
        catch (e) {
            logger.warn('failed to send user answer');
        }
    }),
    setShouldShowPopup(value) {
        self.shouldShowPopup = value;
    },
    setShouldCheckDismissLogicOrValid(value) {
        self.shouldCheckDismissLogicOrValid = value;
    },
    updateInvalidAnswers: flow(function* updateInvalidAnswers(id, contactId) {
        const updatedInvalidAnswers = self.invalidAnswers + 1;
        try {
            const patchData = {
                userId: id,
                invalidAnswers: updatedInvalidAnswers,
                contactId,
            };
            const promises = [];
            promises.push(updateUgcSettings(id, patchData));
            promises.push(self.fetchUgcUserSettings());
            yield Promise.all(promises);
        }
        catch (e) {
            logger.warn('failed to update ugcData');
        }
    }),
    fetchUserUgcData: flow(function* fetchUserUgcData(userId) {
        try {
            const query = `userId=${userId}`;
            const data = yield fetchUgcData(query);
            self.userAnswers = data === null || data === void 0 ? void 0 : data.map(answer => answer === null || answer === void 0 ? void 0 : answer.contactId);
            self.numOfAnswers = data.length || 0;
        }
        catch (e) {
            logger.warn('failed to fetch ugc data');
        }
    }),
    setAlreadyAnswered(contactId) {
        for (const answerId of self.userAnswers) {
            if (answerId === contactId) {
                self.alreadyAnswered = true;
            }
        }
    },
    setCurrentContact(contact) {
        self.currentContact = contact.id;
    },
});
export default Actions;
